import './Throbber.scss'
import { clx } from '../clx'
import { Portal, usePresence } from '../layer'
import { Spinner } from '../Spinner'

export interface ThrobberProps {
  /** Show while true; it slides in and out at the bottom centre of the viewport. */
  isActive: boolean
  /** Visible text and status message. */
  label?: string
  className?: string
}

/**
 * A floating "loading more" pill, fixed at the bottom centre (ADR 0021), for
 * views that load as you scroll: the rows arrive below the fold, so the
 * indicator must not be. Portalled, never focusable, pointer-transparent.
 */
export function Throbber({ isActive, label = 'Loading more…', className }: ThrobberProps) {
  const { isMounted, isClosing } = usePresence(isActive)
  if (!isMounted) return null
  return (
    <Portal>
      <div
        role="status"
        className={clx('throbber', className)}
        data-state={isClosing ? 'closed' : 'open'}
        aria-hidden={isClosing || undefined}
      >
        <Spinner size="sm" className="throbber__spinner" />
        <span className="throbber__label">{label}</span>
      </div>
    </Portal>
  )
}
